import { InjectionToken } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export interface IFormComponent {
  form: UntypedFormGroup | undefined;
  model: unknown;
  controls: { [key: string]: any } | undefined;
  submitted: boolean;
  validate(): void;
}

export const FORM_COMPONENT_TOKEN = new InjectionToken<IFormComponent>('IFormComponent');
